"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

function _default(fot, contribution, antikrizis, penetration) {
  var value = fot + fot * contribution - fot;
  if (penetration && !antikrizis) return value * (penetration / 100);
  return value;
}